export const aceleresContactDisplayName = name => String(name || '').trim();

export default aceleresContactDisplayName;
